import { useEffect, useState } from 'react';
import { StressStrainChart } from '../../components/feature/StressStrainChart';
import { parseStressStrainCSV, type FilamentTestData } from '../../lib/filamentStressStrain';

export interface CsvSeries {
  name: string;
  path: string;
}

interface CsvSeriesChartProps {
  series: CsvSeries[];
}

const CsvSeriesChart = ({ series }: CsvSeriesChartProps) => {
  const [datasets, setDatasets] = useState<FilamentTestData[]>([]);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;

    Promise.all(
      series.map(async (item) => {
        const response = await fetch(item.path);
        if (!response.ok) return null;
        return parseStressStrainCSV(await response.text(), item.name, item.name);
      })
    ).then((results) => {
      if (cancelled) return;
      const loaded = results.filter((item): item is FilamentTestData => item !== null && item.data.length > 0);
      setDatasets(loaded);
      setStatus(loaded.length > 0 ? 'ready' : 'error');
    });

    return () => {
      cancelled = true;
    };
  }, [series]);

  if (status === 'loading') {
    return <p className="text-sm text-metal-light">グラフを読み込み中...</p>;
  }

  if (status === 'error') {
    return <p className="text-sm text-metal-light">グラフを表示できませんでした。</p>;
  }

  return <StressStrainChart datasets={datasets} />;
};

export default CsvSeriesChart;
